<template lang="pug">
.cp-page-bottom
  //- .join-wrap
  //-   p 加入合作伙伴计划，探索人工智能生态新方向
  //-   a.btn(@click="showModal") 申请试用
  .page-bottom-wrap.w.fix
    img.logo.fl(src="../assets/logo.svg")
    .links-wrap.fl
      .col
        .col-title 发现
        router-link(to="/core") 核心技术
        router-link(to="/apply") 解决方案
        router-link(to="/customer") 运营体系
      .col
        .col-title 产品中心
        router-link(to="/product/dmp") 三峡
        router-link(to="/product/qd") 去电
        router-link(to="/product/AICallbot") 反诈劝阻
        router-link(to="/product/enterprise-call") 企业电话
        router-link(to="/product/voice-push") 来电卫士

      .col
        .col-title 关于我们
        //- a(href="./#/") 最新动态
        router-link(to="/about/callai") 关于去电
        a(href="https://www.zhipin.com/gongsi/0f363f9708d91cc61nJ42N29Eg~~.html", target='_blank') 加入我们
    .follow-us.fl
      .col-title 关注我们
      .icon-wrap.wrap1
        icon.icon(iconClass="iconweixin")
      .icon-wrap
        a(href="http://wpa.qq.com/msgrd?v=3&uin=198708743&site=qq&menu=yes", target='_blank')
          icon.icon(iconClass="iconQQ")
      .wxcode-wrap
        img(src="data:image/jpeg;base64,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")
      p 感谢关注“去电”公众号
    .hot-line.fr
      .col-title 客服热线
      .num.fontA 400-166-1212
  .footer-wrap
    p
      a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002004573", target="_black") 沪公网安备 31011002004573号
      span.half-opacity &nbsp;|&nbsp;
      a(href="https://beian.miit.gov.cn/" target="_blank") 沪ICP备17003985号-2
      span.half-opacity &nbsp;|&nbsp;
      a(href="https://beian.miit.gov.cn/" target="_blank") ICP经营许可证编号:B2-20182824
      span.half-opacity &nbsp;&nbsp;©2023 万蚓网络科技(上海)有限公司 版权所有
    p.half-opacity Powered by 去电万蚓网络科技(上海)有限公司是知名的智能融合通信云开发服务商，去电是万蚓旗下对外标帜
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {
  }
}
</script>
<style lang="stylus">
.cp-page-bottom
  background #030C1D
  padding-bottom 30px
  padding-top 53px
  .page-bottom-wrap
    margin-bottom 84px
    .col-title
      color #9EEAFA
      margin-bottom 11px
    .logo
      width 130px
      height 29px
    .links-wrap
      width 460px
      margin-left 96px
      display flex
      justify-content space-between
      .col
        a
          display block
          color #59B5C8
          margin-bottom 6px
          cursor pointer
          transition all .3s
          &:hover
            color #b7f1fd
    .follow-us
      margin-left 114px
      .icon-wrap
        display inline-block
        background #FFF
        opacity 0.5
        border-radius 50%
        width 30px
        height 30px
        transition all .3s
        .icon
          width 30px
          height 30px
        &:hover
          opacity 1
      .wrap1
        margin-right 22px
        opacity 1
      .wxcode-wrap
        width 120px
        height 120px
        margin-top 10px
        background #FFF
        display flex
        justify-content center
        align-items center
        position relative
        &::before
          content ''
          display block
          position absolute
          top -14px
          left 10px
          border-style solid
          border-width 7px 5px
          border-color transparent transparent #FFF
        img
          width 100%
          border-radius 5px
      p
        margin-top 6px
        font-size 12px
        color rgba(230,248,255,1)
    .hot-line
      .num
        font-size 24px
  .footer-wrap
    width 740px
    margin 0 auto
    p, p span
      font-size 12px
      color #76a7b1
    p
      a
        color #76a7b1
        opacity .5
        transition all .3s
        &:hover
          opacity 1
    .half-opacity
      opacity .5
</style>
